module.exports = __webpack_public_path__ + "static/media/Img_2.e7544436.jpg";